var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #ccc;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.1,33.56c-.18.4-.29.84-.29,1.3,0,1.73,1.39,3.14,3.11,3.14s3.11-1.4,3.11-3.14c0-.45-.1-.87-.27-1.26-1.89.05-3.77-.03-5.66-.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.07,35.16H15.54c-.44,0-.84-.24-1.06-.61-.22-.38-.21-.85.01-1.22.9-1.51,1.37-5.23,1.37-6.99v-5.61c.18-4.91,4.1-8.72,8.93-8.72s8.75,3.81,8.93,8.67v3.47c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21v-3.42c-.13-3.51-2.99-6.29-6.5-6.29s-6.37,2.78-6.5,6.33v5.57c0,1.51-.28,5-.82,6.4h16.59c.67,0,1.21.54,1.21,1.21s-.54,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.52 28.43 34.99 22.39 32.52 23.82 30.05 22.39 32.52 28.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.46,
    y: 32.34,
    width: 3.21,
    height: 3.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationGray);
export default __webpack_public_path__ + "static/media/notification_gray.29f69ad85cad96f0ea3f808804474396.svg";
export { ForwardRef as ReactComponent };